import { Component } from 'react';
// import * as t from '../translate';
import {langs} from '../translate/langs';
import {browserHistory} from 'react-router'


export default class InterfaceLang extends Component {

    /**
     * Detects the language and redirects to the proper staring url
     * @return {[type]} [description]
     */
    componentWillMount() {
        let longLang = window.navigator.userLanguage || window.navigator.language;
        let shortLang = longLang.split('-')[0];
        let allLangs = Object.keys(langs);
        let myLangIdx = allLangs.indexOf(shortLang);
        let myLang = 'en';

        if (myLangIdx !== -1){
            myLang = allLangs[myLangIdx];
        }

        browserHistory.push('/' + myLang);
    }

    /**
     * This compnent only needs to detect language, so it renders nothing
     * @return {[type]} [description]
     */
    render(){
        return false;
    }

}





/** WEBPACK FOOTER **
 ** ./src/components/DetectLang.js
 **/